import { render } from "./ContentToDownload.vue?vue&type=template&id=29e5d4f9"
import script from "./ContentToDownload.vue?vue&type=script&lang=js"
export * from "./ContentToDownload.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__